<template>
  <div>
    <Row
      class="menu"
      v-if="!currentCityCode"
    >
      <i-col span="12">
        <a class="m-r-20" href="/">数据服务<!-- <div class="new-menu">beta</div> --></a>
        <a class="m-r-20" href="/lineHistory">开通历程</a>
        <a class="m-r-20" href="/introduce">平台简介</a>
        <a
          class="m-r-20"
          href="/contact"
        >联系我们</a>
        <a
          class="m-r-20"
          @click="showModalMessage"
        >留言反馈</a>
        <a
          class="m-r-20"
          href="/help/#"
        >使用说明</a>

        <a
          class="m-r-20"
          href="/bidding"
        >招标信息</a>

      </i-col>
      <i-col
        span="12"
        class="text-right p-r-20"
        v-if="userInfo&&userInfo.userId"
      >
        <!-- <a class="m-r-20">使用说明</a> -->
        <span
          style="cursor:pointer;"
          class="m-r-10"
          @click="bindwxUser"
        > {{userInfo.name}}</span>
        <Button
          type="default"
          size="small"
          @click="Loginout"
        >退出登录</Button>
      </i-col>
      <i-col
        span="12"
        class="text-right p-r-20"
        v-else
      >
        <Button
          class="btn-primary"
          style="width:60px"
          size="small"
          @click="showLogin"
        >登录</Button>
      </i-col>
    </Row>

    <router-view />

    <Modal
      v-model="showModalLogin"
      width="500"
      :footer-hide="true"
      :mask-closable="false"
    >
      <component
        :is="currentComponent"
        :wxUid="wxUid"
        :appid="cropId"
        @bindFinished="bindFinished"
      ></component>
    </Modal>

    <!-- 弹窗联系我们 -->
    <Modal
      v-model="modalContactUs"
      title="请留下您宝贵的意见！"
      :footer-hide="true"
    >
      <Form
        ref="messageBean"
        :model="formItem"
        :rules="ruleInline"
        :label-width="70"
        class="p-r-10"
      >
        <FormItem
          label="联系人"
          prop="contacter"
        >
          <i-input
            v-model="formItem.contacter"
            maxlength="10"
            placeholder="请输入您的姓名..."
          ></i-input>
        </FormItem>
        <FormItem
          label="电话"
          prop="tel"
        >
          <i-input
            v-model="formItem.tel"
            maxlength="13"
            placeholder="请输入联系电话，我们会及时与您联系！"
          ></i-input>
        </FormItem>
        <FormItem label="留言">
          <i-input
            v-model="formItem.mark"
            type="textarea"
            maxlength="500"
            :rows="5"
            placeholder="请输入您想给我们的任何信息..."
          ></i-input>
        </FormItem>
        <FormItem>
          <Button
            class="btn-oohforce"
            @click="handleSubmitMessage"
          >提交</Button>
          <Button
            style="margin-left: 8px"
            @click="modalContactUs=false"
          >取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { addContactMsg } from '@/api/website'
import { getCompanySetting } from '@/api/companyV2'
import { getUrlQuery } from '../utils/common.js'
import { setStorage, removeStorage } from '@/utils/storage'
import axios from 'axios'
const CryptoJS = require('crypto-js')
const qs = require('qs')

export default {
  name: 'layout',
  components: {
    qrCodeLogin: (resolve) => { require(['./qrCodeLogin'], resolve) },
    userlogin: (resolve) => { require(['./login'], resolve) },
    binduser: (resolve) => { require(['./bindUser'], resolve) },
    bindwxUser: (resolve) => { require(['./bindwxUser'], resolve) }
  },
  data () {
    return {
      currentCityCode: this.$route.params.id,
      showModalLogin: false,
      loginType: this.$store.state.main.show_wwlogin,
      wxUid: '',
      cropId: '',
      currentComponent: '',

      modalContactUs: false,
      formItem: {
        contacter: '',
        tel: '',
        mark: ''
      },
      ruleInline: {
        contacter: [
          // { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        tel: [
          // { required: true, message: '请填写联系方式', trigger: 'blur' },
          {
            pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
            message: '请正确填写联系电话'
          }
        ]
      },
      curCity: 'default',
      cityArray: [
        { value: 'default', name: '默认' },
        { value: 'chengdu', name: '成都' },
        { value: 'xiamen', name: '厦门' }
      ]
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo.user
    },
    openId () {
      return this.$store.state.userInfo.openId
    }
  },
  watch: {
    userInfo (val) {
      if (val && val.companyId < 1) {
        this.currentComponent = 'bindwxUser'
        this.showModalLogin = true
      } else {
        this.currentComponent = ''
        this.showModalLogin = false
        this.loadUserCompanySetting()
      }
    }
  },
  mounted () {
    this.init()

    let searchRouterArray = JSON.parse(sessionStorage.getItem('searchRouters')) || []
    if (searchRouterArray && !searchRouterArray.some(x => x.name === this.$route.name)) {
      searchRouterArray.push({ sort: 1, name: this.$route.name, title: this.$route.meta.description, path: this.$route.path })
    }
    sessionStorage.setItem('searchRouters', JSON.stringify(searchRouterArray))
  },
  beforeUpdate () {
    let searchRouterArray = JSON.parse(sessionStorage.getItem('searchRouters')) || []
    if (searchRouterArray && !searchRouterArray.some(x => x.name === this.$route.name)) {
      const lastSort = searchRouterArray[searchRouterArray.length - 1].sort
      searchRouterArray.push({ sort: lastSort + 1, name: this.$route.name, title: this.$route.meta.description, path: this.$route.path })
    } else {
      const routerIndex = searchRouterArray.findIndex(x => x.name === this.$route.name)
      searchRouterArray.splice(routerIndex + 1, searchRouterArray.length - routerIndex + 1)
    }
    sessionStorage.setItem('searchRouters', JSON.stringify(searchRouterArray))
  },
  methods: {
    bindwxUser () {
      if (this.userInfo && this.userInfo.companyId < 1) {
        this.currentComponent = 'bindwxUser'
        this.showModalLogin = true
      }
    },
    // 绑定F码成功，重新登录
    bindFinished () {
      this.showModalLogin = false
      if (this.openId) {
        let query = {
          'grant_type': 'openid',
          'appid': this.$store.state.main.wxappid,
          'openid': this.openId
        }
        axios.post(process.env.API_URL + '/ooh-auth/oauth/token',
          qs.stringify(query),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic b29oX3B1YmxpYzpvb2hfc2VjcmV0X3B1YmxpYw=='
            }
          }
        ).then(res => {
          this.$store.commit('set_userInfo_user', res.data)
          setStorage('authToken', `${res.data.token_type} ${res.data.access_token}`, 10800)
          setStorage('refresh-token', res.data.refresh_token, 10800)
        })
      }
    },
    init () {
      var code = getUrlQuery('code', window.location.href)
      this.cropId = getUrlQuery('appid', window.location.href)

      if (code) {
        // 如果URL中包含CODE代码， 那么根据情况调整页面
        let scanBean = {
          appId: this.cropId,
          code: code
        }

        this.$store.dispatch('LoginByScan', scanBean).then((data) => {
          const privateKey = data.privateKey
          const urlLoader = data.url
          // 加密登录信息,直接传输UserId
          const token = {
            Uid: data.scanUserId,
            AppId: this.cropId,
            website: process.env.WEBSIT,
            type: data.type
          }

          const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(token), privateKey).toString()
          window.location.href = urlLoader + '?token=' + encodeURIComponent(ciphertext)
        }).catch((error) => {
          // CODE为未绑定的用户
          if (error.errcode === -7) {
            this.currentComponent = 'binduser'
            this.showModalLogin = true
            this.wxUid = error.errmsg
          } else {
            // CODE无效， 暂不作任何处理
          }
        })
      }
    },
    showLogin () {
      if (this.loginType === 0) {
        this.currentComponent = 'userlogin'
      } else {
        this.currentComponent = 'qrCodeLogin'
      }
      this.showModalLogin = true
    },
    Loginout () {
      this.$Modal.confirm({
        title: '确定登出？',
        content: '<p>您是否要退出当前登录状态？</p>',
        loading: true,
        onOk: () => {
          removeStorage('authToken')
          removeStorage('refresh-token')
          this.$store.commit('set_userInfo_openId', '')
          this.$store.commit('set_userInfo_user', null)
          this.$store.commit('set_user_companySetting', null)
          this.$Modal.remove()
          window.location.replace('/')
        }
      })
    },
    showModalMessage () {
      this.modalContactUs = true

      this.formItem = {
        contacter: '',
        tel: '',
        mark: ''
      }
    },
    handleSubmitMessage () {
      this.$refs['messageBean'].validate((valid) => {
        if (valid) {
          addContactMsg(this.formItem).then(res => {
            if (res.errcode === 0) {
              this.$Notice.success({
                title: '操作成功',
                desc: '感谢您的留言， 我们会尽快与您联系！'
              })
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: '抱歉，发生一个异常问题， 我们正在全力修复中！'
              })
            }
            this.modalContactUs = false
          })
        }
      })
    },
    loadUserCompanySetting () {
      getCompanySetting({ companyId: this.userInfo.companyId }).then(res => {
        this.$store.commit('set_user_companySetting', res)
        window.location.replace('/')
      })
    }
  }
}
</script>
